<template>
  <div>
    <el-dialog
      width="1125px"
      v-loading="loadingData"
      :visible="historyModalVisible"
      :before-close="handleCloseModal"
      :close-on-click-modal="false"
      @opened="buildFlowChart"
    >
      <div class="call-flow-info mb-10" v-if="currentCall">
        <h2 class="form-section-header">Call Flow View</h2>
        <div class="flex-three">
          <div class="call-flow-info-item flex">
            <h4 class="black-text mt-0 mb-0">Unique Id:</h4>
            <span class="ml-10 black-text">{{ currentCall.uniqueId }}</span>
          </div>
          <div class="call-flow-info-item flex">
            <h4 class="black-text mb-0 mt-0">Start Time:</h4>
            <span class="black-text ml-10">{{
              callFlowTimeFormat(currentCall.start)
            }}</span>
          </div>
          <div class="call-flow-info-item flex">
            <h4 class="black-text mb-0 mt-0">Duration:</h4>
            <span class="black-text ml-10">{{
              convertTime(currentCall.duration)
            }}</span>
          </div>
        </div>
        <div class="flex-three mt-5">
          <div class="call-flow-info-item flex">
            <h4 class="black-text mt-0 mb-0">Caller Number:</h4>
            <span class="ml-10 black-text">{{
              numberFormatter(currentCall.callerIdNumber)
            }}</span>
          </div>
          <div class="call-flow-info-item flex">
            <h4 class="black-text mb-0 mt-0">Number Dialed:</h4>
            <span class="black-text ml-10">{{
              numberFormatter(currentCall.dialedNum)
            }}</span>
          </div>
          <div class="call-flow-info-item flex">
            <h4 class="black-text mb-0 mt-0">Disposition:</h4>
            <span class="black-text ml-10">{{ currentCall.disposition }}</span>
          </div>
        </div>
      </div>

      <div>
        <vxe-grid
          round
          border="inner"
          height="300px"
          auto-resize
          empty-text="No Data"
          highlight-hover-row
          show-overflow="tooltip"
          :data="callData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :columns="eventColumns"
        />
      </div>
    </el-dialog>
    <div id="call-records-view" class="page-table scrollable only-y">
      <el-dialog
        width="440px"
        :visible="modalVisible"
        :before-close="handleCloseModal"
        :close-on-click-modal="false"
      >
        <h2 class="form-section-header">Filter Settings</h2>
        <h3 class="black-text mb-10">Select Date Range</h3>
        <el-date-picker
          :clearable="false"
          class="mr-10"
          style="margin-left: auto"
          v-model="historyDateRange"
          type="datetimerange"
          align="right"
          unlink-panels
          format="yyyy-MM-dd HH:mm"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="datePickerOptions"
        >
        </el-date-picker>

        <el-form id="records-advanced-modal" class="form-modal">
          <h3 class="black-text mb-0">Filter By</h3>
          <div>
            <el-checkbox
              class="filter-checkbox"
              v-model="filterByIvrs"
              label="Virtual Receptionist"
              style="margin-left: 0"
            />
          </div>

          <div v-if="filterByIvrs">
            <el-select
              v-model="filterIvrs"
              value-key="id"
              placeholder="Select Ivrs"
              clearable
              multiple
              filterable
              style="margin-top: 0"
            >
              <el-option
                v-for="item in ivrOptions"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              />
            </el-select>
          </div>

          <div>
            <el-checkbox
              class="filter-checkbox"
              v-model="filterByCallId"
              label="Call Id"
              style="margin-left: 0"
            />
          </div>
          <el-input
            v-if="filterByCallId"
            placeholder="Enter Call Id"
            v-model="theCallId"
          >
            <template slot="prefix"> Call Id </template>
          </el-input>

          <h3 class="black-text mb-5 mt-5">Select Events</h3>
          <el-select v-model="events" multiple>
            <el-option
              v-for="(item, index) in eventOptions"
              :key="index"
              :value="item"
              :label="eventFormatter(item)"
            />
            <template slot="prefix">
              <span style="opacity: 0">Dad</span>
            </template>
          </el-select>

          <el-button @click="doAdvanced" class="mt-20"> Update </el-button>
        </el-form>
      </el-dialog>

      <div class="no-table-box page-header">
        <div class="flex justify-space-between mb-20">
          <h2 class="mb-0 mt-0 text-left">
            <v-svg sprite="flow" class="voxo-blue"></v-svg>
            Virtual Receptionists Records
          </h2>
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px"></i>
            Total: {{ total | number }}
          </el-tag>
        </div>

        <div class="flex align-center mb-20">
          <el-radio-group
            v-model="presetSelection"
            @change="doPreset"
            class="hidden-xs-only"
          >
            <el-radio-button type="default" label="yesterday"
              >Yesterday</el-radio-button
            >
            <el-radio-button type="default" label="last10"
              >Last 10 Days</el-radio-button
            >
            <el-radio-button label="lastMonth">Last 30 Days</el-radio-button>
          </el-radio-group>

          <el-tooltip placement="top" :content="selectedDateRange">
            <el-button @click="modalVisible = true" class="ml-10">
              Filter
            </el-button>
          </el-tooltip>
          <el-button
            @click="resetTable"
            v-if="advancedActive"
            style="background-color: #f25a6b; color: #fff"
          >
            Reset
          </el-button>
          <el-button
            class="ml-10"
            @click="doExport"
            :disabled="!tableData.length"
          >
            Export
          </el-button>
          <el-pagination
            small
            background
            layout="prev, pager, next"
            @current-change="pageSet"
            @next-click="pageNext"
            @prev-click="pagePrevious"
            :current-page="page"
            :page-size="150"
            :pager-count="5"
            :total="total"
            v-if="total > limit"
            style="margin-left: auto"
          />
        </div>

        <div class="vxe-table-height-tabs card-base card-shadow--medium">
          <vxe-grid
            round
            border="inner"
            ref="xGrid"
            height="100%"
            auto-resize
            empty-text="No Data"
            show-overflow="tooltip"
            highlight-hover-row
            @cell-click="cellClicked"
            @cell-mouseenter="rowHover"
            @cell-mouseleave="rowLeave"
            :data="tableData"
            :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
            :loading="loadingData"
            :columns="tableColumns"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import feathersClient, { apiV2Host } from "@/feathers/feathers-client";
import debounce from "lodash/debounce";
import moment from "moment";
import { ExportToCsv } from "export-to-csv";
import { phoneNumberFormatter } from "@/globals/globals";

export default {
  name: "IVRLogsTable",
  props: {
    ivrOptions: { required: true },
  },
  data() {
    return {
      visibleActionsId: null,
      callData: [],
      eventColumns: [
        { field: "event", title: "Event", sortable: false, showOverflow: false, width: 500 },
        { field: "time", title: "Time", sortable: false, minWidth: 250, showOverflow: false },
      ],
      from: null,
      to: null,
      search: "",
      page: 1,
      limit: 150,
      total: 0,
      loadingData: false,
      advancedActive: false,
      modalVisible: false,
      historyModalVisible: false,
      presetSelection: "last10",
      tableData: [],
      startDate: null,
      endDate: null,
      direction: "All",
      currentCall: null,
      lastFlowId: null,
      exportCSV: false,
      ivrIds: [],
      filterIvrs: [],
      filterByIvrs: false,
      filterByCallId: false,
      theCallId: "",
      ivrNameKey: {},
      events: ["SELECT", "WRONG", "DISA", "TIMEOUT", "HANGUP", "ENTER"],
      eventOptions: ["SELECT", "WRONG", "DISA", "TIMEOUT", "HANGUP", "ENTER"],
      historyDateRange: [moment(), moment()],
      datePickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(1, "week").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(1, "month").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(3, "months").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 6 months",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(6, "months").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last year",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(12, "months").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-blue" sprite="flow" />
                </div>,
              ];
            },
          },
        },
        {
          field: "time",
          title: "Time",
          minWidth: 160,
          slots: {
            default: ({ row }) => {
              return [<span>{this.timeFormatter(row.time)}</span>];
            },
          },
        },
        {
          field: "ivrId",
          title: "IVR",
          minWidth: 225,
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              return [<span>{this.findIVRName(row.ivrId)}</span>];
            },
          },
        },
        {
          field: "event",
          title: "Event",
          minWidth: 175,
          slots: {
            default: ({ row }) => {
              return [<span>{this.eventFormatter(row.event)}</span>];
            },
          },
        },
        {
          field: "callerNumber",
          title: "Caller Num",
          minWidth: 175,
          slots: {
            default: ({ row }) => {
              return [
                <span>
                  {this.numberFormatter(row.callerNumber).replace(/>/g, "")}
                </span>,
              ];
            },
          },
        },
        {
          field: "loop",
          title: "Loop #",
          minWidth: 75,
        },
        {
          field: "extDialed",
          title: "Ext Dialed",
          minWidth: 100,
        },
        {
          field: "keyPressed",
          title: "Key",
          minWidth: 75,
        },
        {
          field: "callerName",
          title: "Caller Name",
          minWidth: 175,
          showOverflow: true,
        },
        {
          field: "actions",
          title: "",
          minWidth: "200",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"delete-" + row.id}
                    type="primary"
                    icon="mdi mdi-history"
                    size="mini"
                    onClick={() => this.getCallHistory(row)}
                    class="table-action-button"
                  />
                </div>,
              ];
            },
          },
        },
      ],
    };
  },
  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    },
    userOffsetMinutes() {
      return this.$store.state.userTimeOffset;
    },
    selectedDateRange() {
      if (this.endDate && this.startDate) {
        const dateStart = moment(this.startDate).format("M/D/YY HH:mm");
        const dateEnd = moment(this.endDate).format("M/D/YY HH:mm");
        return `${dateStart} - ${dateEnd}`;
      }
    },
  },
  watch: {
    page: debounce(function () {
      this.queryIvrRecords();
    }, 500),
    selectedTenant() {
      this.loadingData = true;
    },
  },
  methods: {
    queryIvrRecords() {
      this.loadingData = true;

      if (this.ivrIds.length) {
        feathersClient
          .service("ivr-log")
          .find({
            query: {
              type: "ivrLogReport",
              ivrId: this.filterByIvrs ? this.filterIvrs : this.ivrIds,
              startDate: this.startDate,
              endDate: this.endDate,
              event: this.events,
              exportCSV: this.exportCSV,
              timezone: this.user.timezone,
              tenantId: this.selectedTenant.id,
              filterByCallId: this.filterByCallId,
              theCallId: this.theCallId,
              $sort: { time: -1 },
              $limit: this.limit,
              $skip: this.page > 1 ? this.limit * (this.page - 1) : 0,
            },
          })
          .then((res) => {
            if (!this.exportCSV) {
              this.limit = res.limit;
              this.pages = Math.ceil(res.total / res.limit);
              this.total = res.total;
              this.page = this.page > this.pages ? 1 : this.page;
              this.tableData = res.data;
            }

            if (this.exportCSV) {
              if (!res.url) {
                this.$notify({
                  title: "Not Found",
                  message: "File Not Found.",
                  type: "warning",
                });
              } else {
                this.downloadCSV(res);
              }
            }

            this.exportCSV = false;
            this.loadingData = false;
          })
          .catch(() => {
            this.loadingData = false;
          });
      }
    },
    resetTable() {
      this.advancedActive = false;
      this.filterByIvrs = false;
      this.filterByCallId = false;
      this.theCallId = "";
      this.ivrIds = [];
      this.filterIvrs = [];
      this.ivrNameKey = {};
      this.events = ["SELECT", "WRONG", "DISA", "TIMEOUT", "HANGUP", "ENTER"];
      for (let i = 0; i < this.ivrOptions.length; i++) {
        this.ivrIds.push(this.ivrOptions[i].id);
        this.ivrNameKey[this.ivrOptions[i].id] = this.ivrOptions[i].name;
      }
      this.doPreset("init");
    },
    doPreset(val) {
      if (val === "init") {
        this.endDate = moment(moment().format("YYYY-MM-DD"))
          .add(1, "day")
          .subtract(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.startDate = moment().startOf("day").format("YYYY-MM-DD");
        this.presetSelection = "init";
        this.updateDateRangePicker();
        this.queryIvrRecords();
      }

      if (val === "last10") {
        this.endDate = moment(moment().format("YYYY-MM-DD"))
          .add(1, "day")
          .subtract(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.startDate = moment().subtract(9, "days").format("YYYY-MM-DD");
        this.presetSelection = "last10";
        this.updateDateRangePicker();
        this.queryIvrRecords();
      }

      if (val === "lastMonth") {
        this.endDate = moment(moment().format("YYYY-MM-DD"))
          .add(1, "day")
          .subtract(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
        this.presetSelection = "lastMonth";
        this.updateDateRangePicker();
        this.queryIvrRecords();
      }

      if (val === "yesterday") {
        this.endDate = moment()
          .startOf("day")
          .subtract(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.startDate = moment()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm");
        this.presetSelection = "yesterday";
        this.updateDateRangePicker();
        this.queryIvrRecords();
      }
    },
    doAdvanced() {
      this.startDate = moment(this.historyDateRange[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.endDate = moment(this.historyDateRange[1]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.queryIvrRecords();
      this.handleCloseModal();
      this.advancedActive = true;
    },
    doExport() {
      this.$confirm(`Export data for ${this.total} records?`, {
        type: "warning",
      })
        .then(() => {
          if (this.pages === 1) {
            //export from browser
            let csvData = [];
            for (let i = 0; i < this.tableData.length; i++) {
              const csvObject = {};
              let exclusionList = ["_XID"];
              for (let key in this.tableData[i]) {
                if (exclusionList.includes(key) === false) {
                  csvObject[key] = this.tableData[i][key]
                    ? this.tableData[i][key]
                    : "";
                }
              }
              csvData.push(csvObject);
            }

            const options = {
              filename: "ivr_log_records",
              showLabels: true,
              headers: [
                "Time",
                "Virtual Receptionist",
                "Event",
                "Key Pressed",
                "EXT Dialed",
                "Loop #",
                "Caller Number",
                "Caller Name",
                "Call Id",
              ],
            };

            let csvReorder = csvData.map((obj) => {
              let reorderObj = {};
              reorderObj["time"] = this.timeFormatterExport(obj.start);
              reorderObj["virtualReceptionist"] = this.findIVRName(obj.ivrId);
              reorderObj["event"] = this.eventFormatter(obj.event);
              reorderObj["keyPressed"] = obj.keyPressed;
              reorderObj["extDialed"] = obj.extDialed;
              reorderObj["loop#"] = obj.loop;
              reorderObj["callerNumber"] = this.numberFormatter(
                obj.callerNumber
              ).replace(/>/g, "");
              reorderObj["callerName"] = obj.callerName;
              reorderObj["callId"] = obj.uniqueId;

              return reorderObj;
            });

            csvData.push(csvReorder);
            const csvExporter = new ExportToCsv(options);
            csvExporter.generateCsv(csvReorder);
          } else {
            this.exportCSV = true;
            this.queryIvrRecords();
          }
        })
        .catch(() => true);
    },
    downloadCSV(data) {
      const { url, downloadName } = data;
      const link = document.createElement("a");
      link.href = url;
      link.download = downloadName;
      link.click();
    },
    numberFormatter(val) {
      return phoneNumberFormatter(val);
    },
    numberFormatterTable(row, column, val) {
      return phoneNumberFormatter(val);
    },
    timeFormatter(value) {
      const offsetMinutes = Math.abs(this.userOffsetMinutes);

      return this.userOffsetMinutes < 0
        ? moment(value)
            .subtract(offsetMinutes, "minutes")
            .format("M/DD h:mm:ss A")
        : moment(value).add(offsetMinutes, "minutes").format("M/DD h:mm:ss A");
    },
    timeFormatterExport(value) {
      const offsetMinutes = Math.abs(this.userOffsetMinutes);

      return this.userOffsetMinutes < 0
        ? moment(value)
            .subtract(offsetMinutes, "minutes")
            .format("YY/MM/DD hh:mm:ss A")
        : moment(value)
            .add(offsetMinutes, "minutes")
            .format("YY/MM/DD hh:mm:ss A");
    },
    callFlowTimeFormat(time) {
      const offsetMinutes = Math.abs(this.userOffsetMinutes);

      return this.userOffsetMinutes < 0
        ? moment(time)
            .subtract(offsetMinutes, "minutes")
            .format("M/DD h:mm:ss A")
        : moment(time).add(offsetMinutes, "minutes").format("M/DD h:mm:ss A");
    },
    handleCloseModal() {
      this.modalVisible = false;
      this.historyModalVisible = false;
      this.callData = [];
    },
    updateDateRangePicker() {
      this.historyDateRange = [moment(this.startDate), moment(this.endDate)];
    },
    pageNext() {
      if (this.page < this.pages) {
        this.page += 1;
      }
    },
    pagePrevious() {
      if (this.page > 1) {
        this.page -= 1;
      }
    },
    pageSet(page) {
      this.page = page;
    },
    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.getCallHistory(data.row);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },
    async getCallHistory(row) {
      const { uniqueId, time } = row;

      this.loadingData = true;
      this.callData = [];
      await feathersClient.service('call-history').find({
        query: {
          queryType: 'callHistory',
          primaryFilter: 'callId',
          callId: uniqueId,
          tenantId: this.selectedTenant.id,
          startDate: moment(time).hour(0).minute(0).second(0).millisecond(0).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(time).hour(23).minute(59).second(59).millisecond(999).format('YYYY-MM-DD HH:mm:ss'),
          dispositions: ['ANSWERED', 'NO ANSWER', 'BUSY', 'FAILED'],
          direction: 'All',
          $limit: 100,
          $skip: 0,
        }
      }).then( res => {
        if (res.total === 0) {
          this.loadingData = false;
          this.historyModalVisible = false;
          this.currentCall = null;
          this.$notify({
            title: "No History Found",
            message: "No history found for this call.",
            type: "warning",
          });
          return;
        }
        this.historyModalVisible = true;
        this.loadingData = false;
        this.currentCall = res.data[0];
      });
    },
    getRandomKey() {
      const randomString = () => Math.random().toString(36).slice(2);
      return `${randomString()}-${randomString()}$${randomString()}`;
    },
    async buildFlowChart() {
      this.loadingData = true;
      const url = `${apiV2Host}/admin/reporting/calls/call-journey`;
      const body = { callId: this.currentCall.callId };
      try {
        const callRecords = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.accessToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
        const [{ callJourney }] = await callRecords.json();
        for (let i = 0; callJourney.length > i; i++) {
          this.callData.push({
            event: callJourney[i].data,
            time: moment(callJourney[i].timestamp).format("hh:mm:ss.SSS A")
          });
        }
      } catch (error) {
        console.error("Error fetching call records:", error);
      }
      this.loadingData = false;
    },
    convertTime(time) {
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);

      if (hours > 0) {
        return hours + "hr " + minutes + "m";
      }
      if (minutes > 0) {
        return minutes + "m";
      }
      if (seconds > 0) {
        return seconds + "s";
      }
      return "0";
    },
    findIVRName(value) {
      return this.ivrNameKey[value];
    },
    eventFormatter(value) {
      const eventMap = {
        WRONG: "Wrong Key",
        SELECT: "Valid Key",
        HANGUP: "Hangup",
        ENTER: "Enter",
        TIMEOUT: "Timeout",
        DISA: "Ext Dial",
      };
      return eventMap[value];
    },
  },
  mounted() {
    this.doPreset("init");
  },
  beforeDestroy() {},
  filters: {
    number(value) {
      return !isNaN(value)
        ? new Intl.NumberFormat("en-US").format(value)
        : value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_variables.scss";

.el-form {
  .el-select {
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
}

.dispositions-group {
  .el-checkbox {
    margin-left: 0;
    display: inline-flex;
    align-items: center;
  }
}

.flex-three {
  display: flex;
  > * {
    flex-basis: 33.3333333%;
  }
}

.filter-checkbox {
  margin-left: 0;
  display: inline-block;
  margin-top: 5px;
}

.small-svg {
  width: 20px;
  height: 20px;
}
</style>
